import { SET_ACCOUNTLESS_APP_ENTRY } from 'stash/actions/accountlessAppEntry';

export type AccountlessAppEntryState = {
	isEnabled: boolean;
};

export const initialState: AccountlessAppEntryState = {
	isEnabled: false,
};

type AccountlessAppEntryAction = {
	type: string;
	isEnabled?: boolean;
};

// Resolved from the web-reg cookie by the session middleware whenever a session
// starts, which covers both app boot and a log in without a page reload.
// Defaults to disabled until then.
const accountlessAppEntryReducer = (
	state = initialState,
	action: AccountlessAppEntryAction = { type: '' }
): AccountlessAppEntryState => {
	switch (action.type) {
		case SET_ACCOUNTLESS_APP_ENTRY:
			return { ...state, isEnabled: action.isEnabled === true };
		default:
			return state;
	}
};

export default accountlessAppEntryReducer;
